// codeblue_formTracking.js - Complete Fixed Version with CORS Handling

(function() {
    'use strict';

    // Define form field order/steps
    const FORM_STEPS = {
        'name': { step: 1, label: 'Name Field' },
        'email': { step: 2, label: 'Email Field' },
        'phone_number': { step: 3, label: 'Phone Field' },
        'Indoor': { step: 4, label: 'Indoor Placement' },
        'Outdoor': { step: 4, label: 'Outdoor Placement' },
        'D_Blade': { step: 5, label: '3D Metal Blade Sign' },
        'Acrylic_Storefront_Sign': { step: 5, label: 'Acrylic Storefront Sign' },
        'Metal_Backlit': { step: 5, label: '3D Metal Back-lit' },
        'D_Metal_Acrylic': { step: 5, label: '2D Metal/Acrylic' },
        'D_Frontlit_Backlit': { step: 5, label: '3D Frontlit & Backlit' },
        'Lightbox': { step: 5, label: 'Lightbox' },
        'Blade_Sign': { step: 5, label: 'Blade Sign' },
        'Acrylic_Frontlit': { step: 5, label: 'Acrylic Frontlit' },
        'D_LetterSign': { step: 5, label: '3D Letter Sign' },
        'Three_D_Sign': { step: 5, label: '3D Sign' },
        'details': { step: 6, label: 'Details Field' },
        'imageUrl': { step: 7, label: 'Image URL' },
        'fileInput': { step: 7, label: 'File Upload' }
    };

    // Base API URL - use full URL to avoid relative path issues
    const BASE_API_URL = 'https://api.analytics.codeblue.agency/api/track';

    // Wait for DOM and analytics to be ready
    window.addEventListener('DOMContentLoaded', function() {
        // CRITICAL: Check global blocking flag first
        if (window.__TRACKING_BLOCKED__ === true) {
            return;
        }

        // Get analytics instance with retry logic
        let analytics = window.__ANALYTICS_TRACKER__?.getInstance();
        
        if (!analytics) {
            // Retry after delay
            setTimeout(() => {
                analytics = window.__ANALYTICS_TRACKER__?.getInstance();
                
                // Check blocking flag again
                if (window.__TRACKING_BLOCKED__ === true) {
                    return;
                }
                
                if (!analytics || !analytics.isAllowed()) {
                    return;
                }
                
                initFormTracking(analytics);
            }, 1500);
            return;
        }
        
        if (!analytics.isAllowed()) {
            return;
        }
        
        initFormTracking(analytics);
    });

    function initFormTracking(analytics) {
        // Initialize tracking for the quote form
        const form = document.getElementById('quoteForm');
        if (!form) {
            console.error('[FormTracking] Quote form not found');
            return;
        }

        // Set form type as data attribute
        form.setAttribute('data-form-type', 'Quote Request Form');

        // Generate unique form ID
        const formId = 'form_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        let formStarted = false;
        let currentStep = 0;
        let highestStepReached = 0;

        // console.log('[FormTracking] ✅ Form tracking initialized for quoteForm');

        // Enhanced API call function with better error handling
        const makeAPICall = async (endpoint, data) => {
            try {
                // Verify we have required credentials
                if (!analytics.apiKey || !analytics.sessionId) {
                    console.warn('[FormTracking] Missing analytics credentials');
                    return null;
                }

                const response = await fetch(`${BASE_API_URL}${endpoint}`, {
                    method: (endpoint === '/form/start' || endpoint === '/form/submit') ? 'POST' : 'PUT',
                    headers: { 
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        api_key: analytics.apiKey,
                        session_id: analytics.sessionId,
                        ...data
                    }),
                    redirect: 'error' // Don't follow redirects that cause CORS issues
                });

                if (response.ok) {
                    return await response.json();
                } else {
                    console.warn(`[FormTracking] API call failed: ${response.status}`);
                    return null;
                }
            } catch (error) {
                // Don't log CORS errors to avoid console pollution
                if (error.name !== 'TypeError' || !error.message.includes('Failed to fetch')) {
                    console.warn('[FormTracking] API call error:', error);
                }
                return null;
            }
        };

        // Track when form is started (first interaction)
        const startFormTracking = async () => {
            if (formStarted) return;
            formStarted = true;

            await makeAPICall('/form/start', {
                form_id: formId,
                url: window.location.href,
                form_type: 'Quote Request Form',
                current_step: 1,
                step_name: 'Form Started'
            });
        };

        // Detect first interaction with any form field
        form.addEventListener('focusin', startFormTracking, { once: true });

        // Helper function to get all selected sign types
        const getSelectedSignTypes = () => {
            const signTypeIds = [
                'D_Blade', 'Acrylic_Storefront_Sign', 'Metal_Backlit',
                'D_Metal_Acrylic', 'D_Frontlit_Backlit', 'Lightbox',
                'Blade_Sign', 'Acrylic_Frontlit', 'D_LetterSign', 
                'Three_D_Sign'
            ];
            const selected = signTypeIds.filter(id => {
                const checkbox = form.querySelector(`#${id}`);
                return checkbox && checkbox.checked;
            });
            return selected.map(id => FORM_STEPS[id]?.label || id).join(', ');
        };

        // Helper function to get placement options
        const getPlacementOptions = () => {
            const placements = [];
            if (form.querySelector('#Indoor')?.checked) placements.push('Indoor');
            if (form.querySelector('#Outdoor')?.checked) placements.push('Outdoor');
            return placements.join(', ');
        };

        // Helper function to collect all form data
        const collectFormData = () => {
            return {
                name: form.querySelector('#name')?.value || '',
                email: form.querySelector('#email')?.value || '',
                phone: form.querySelector('#phone_number')?.value || '',
                placement: getPlacementOptions(),
                sign_types: getSelectedSignTypes(),
                details: form.querySelector('#details')?.value || '',
                image_url: form.querySelector('#imageUrl')?.value || '',
                lead_page: form.querySelector('#lead_page')?.value || 'Info Page',
                files_count: form.querySelector('#fileInput')?.files?.length || 0
            };
        };

        // Update current step and track progress
        const updateCurrentStep = (fieldName) => {
            const stepInfo = FORM_STEPS[fieldName];
            if (!stepInfo) return;

            const newStep = stepInfo.step;
            
            // Update current step
            if (newStep > currentStep) {
                currentStep = newStep;
            }

            // Track highest step reached (form progress)
            if (newStep > highestStepReached) {
                highestStepReached = newStep;
                // console.log(`[FormTracking] 📍 Progress: Step ${newStep} - ${stepInfo.label}`);
            }
        };

        // Track field updates with step information
        const updateFormField = async (fieldName, fieldValue, fieldLabel = null) => {
            updateCurrentStep(fieldName);

            const stepInfo = FORM_STEPS[fieldName] || { step: 0, label: fieldName };

            await makeAPICall('/form/update', {
                form_id: formId,
                field_name: fieldName,
                field_value: fieldValue,
                current_step: stepInfo.step,
                step_name: stepInfo.label,
                highest_step: highestStepReached,
                field_label: fieldLabel || stepInfo.label
            });
        };

        // Track text inputs with debouncing
        const textInputs = form.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], textarea');
        textInputs.forEach(input => {
            let timeout;
            
            input.addEventListener('input', () => {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    const fieldName = input.name || input.id;
                    updateFormField(fieldName, input.value);
                }, 1000);
            });

            // Update on blur (when user leaves field)
            input.addEventListener('blur', () => {
                clearTimeout(timeout);
                const fieldName = input.name || input.id;
                updateFormField(fieldName, input.value);
            });

            // Track when user focuses on field (even before filling)
            input.addEventListener('focus', () => {
                const fieldName = input.name || input.id;
                updateCurrentStep(fieldName);
            });
        });

        // Track checkbox changes immediately
        const checkboxes = form.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', () => {
                const fieldName = checkbox.id || checkbox.name;
                
                // For placement checkboxes
                if (fieldName === 'Indoor' || fieldName === 'Outdoor') {
                    const placement = getPlacementOptions();
                    updateFormField('placement', placement, 'Placement Selection');
                } 
                // For sign type checkboxes
                else {
                    const signTypes = getSelectedSignTypes();
                    updateFormField('sign_types', signTypes, 'Sign Type Selection');
                }
            });

            // Track focus on checkbox area
            checkbox.addEventListener('focus', () => {
                const fieldName = checkbox.id || checkbox.name;
                updateCurrentStep(fieldName);
            });
        });

        // Track file selection
        const fileInput = form.querySelector('#fileInput');
        if (fileInput) {
            fileInput.addEventListener('change', (e) => {
                const fileCount = e.target.files.length;
                const fileNames = Array.from(e.target.files).map(f => f.name).join(', ');
                updateFormField('fileInput', `${fileCount} file(s): ${fileNames}`, 'File Upload');
            });
        }

        // Track image URL field separately
        const imageUrlInput = form.querySelector('#imageUrl');
        if (imageUrlInput) {
            let timeout;
            imageUrlInput.addEventListener('input', () => {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    updateFormField('imageUrl', imageUrlInput.value, 'Image URL');
                }, 1000);
            });
        }

        // Track lead page field
        const leadPageInput = form.querySelector('#lead_page');
        if (leadPageInput) {
            let timeout;
            leadPageInput.addEventListener('input', () => {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    updateFormField('lead_page', leadPageInput.value, 'Lead Page');
                }, 1000);
            });
        }

        // Track when user reaches the submit button (scroll into view)
        const submitButton = form.querySelector('.submitButton');
        if (submitButton && 'IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        updateFormField('submit_button_viewed', 'true', 'Submit Button Viewed');
                        observer.disconnect();
                    }
                });
            }, { threshold: 0.5 });

            observer.observe(submitButton);
        }

        // Function to submit form to analytics
        async function submitToAnalytics(formData) {
            try {
                // Update to final step
                currentStep = 8;
                highestStepReached = 8;

                const result = await makeAPICall('/form/submit', {
                    form_id: formId,
                    form_type: 'Quote Request Form',
                    name: formData.name,
                    email: formData.email,
                    phone: formData.phone,
                    details: formData.details || '',
                    image: formData.image_url,
                    status: formData?.status || "Converted",
                    metadata: {
                        placement: formData.placement,
                        sign_types: formData.sign_types,
                        image_url: formData.image_url,
                        lead_page: formData.lead_page,
                        details: formData.details,
                        files_count: formData.files_count,
                        current_step: 8,
                        step_name: 'Form Submitted',
                        highest_step: 8,
                        db_form_id: formData.id || "",
                        airtable_record_id: formData?.airTableRecordId,
                    }
                });

                if (result && result.success) {
                    // console.log('[FormTracking] ✅ Form submitted successfully');
                    
                    // Mark session as converted
                    await makeAPICall('/session', {
                        converted: true
                    });

                    // Reset tracking state
                    formStarted = false;
                    currentStep = 0;
                    highestStepReached = 0;

                    return true;
                }
                return false;
            } catch (error) {
                console.error('[FormTracking] Error submitting form:', error);
                return false;
            }
        }

        // Expose submit function globally for external form handlers
        window.submitFormToAnalytics = async function(customFormData = null) {
            const formData = customFormData || collectFormData();
            return await submitToAnalytics(formData);
        };
    }

})();